import useSWRInfinite from 'swr/infinite'
import { InventoryListItem } from 'types/inventory'
import api from 'v2/api'

type SortParamsType = {
  sort_field?: string[]
  sort_direction?: string
}

export const useOwnerInventories = ({
  ownerId,
  search_params,
  limit,
  sort_params,
}: {
  ownerId: string
  search_params?: Record<string, string>
  limit?: number
  sort_params?: SortParamsType
}) => {
  const getKey = (
    pageIndex: number,
    previousPageData: { inventoryData: InventoryListItem[] },
  ) => {
    if (previousPageData && !previousPageData.inventoryData.length) return null
    return {
      path: `v3/owners/${ownerId}/inventories`,
      search_params,
      page: pageIndex + 1,
      limit,
      sort_params,
    }
  }

  const fetcher = ({
    path,
    search_params,
    page,
    limit,
    sort_params,
  }: {
    path: string
    search_params: Record<string, string>
    page: number
    limit?: number
    sort_params?: SortParamsType
  }) =>
    api
      .get<InventoryListItem[]>(path, {
        params: {
          search_params,
          page,
          limit,
          ...sort_params,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          return {
            inventoryData: res.data,
            xTotalCount: res.headers['x-total-count'],
          }
        } else throw res
      })
      .catch((err) => {
        throw err
      })

  return useSWRInfinite(getKey, fetcher, {
    initialSize: 1,
    revalidateOnFocus: false,
  })
}
